export default class Carousel {
    #container_el
    #container_doc
    #container_window
    #carousel
    #carousel_id
    #model_el
    #remove_slide_history
    #regain_model_data

    constructor(carousel_id) {
        this.#container_el = null
        this.#container_doc = null
        this.#container_window = null
        this.#carousel = null
        this.#carousel_id = carousel_id
        this.#model_el = null
        this.#remove_slide_history = []
        this.#regain_model_data = {}
        this.location_el = null
        this.create_selector = null
        this.slides_per_view = 1
        this.autoplay = {
            status: false,
            delay: 2500,
        }
        this.pagination = {
            status: true,
            color: 'rgba(158, 158, 158, 1)',
        }
        this.next_and_prev = {
            status: true,
            color: 'rgba(0, 0, 0, 1)',
        }
        this.model_size = {
            height: 250,
            width: 600
        }
        this.items = []
        this.default_item_style = {
            height: 100,
            width: 100,
            background: 'rgba(190, 190, 190, 1)'
        }
    }

    _createModelElement(location_el, seat) {
        return new Promise((resolve) => {
            this.#container_el = document.createElement('iframe')
            this.#container_el.setAttribute('style', `width: ${this.model_size.width}px; height: ${this.model_size.height}px; display: flex; max-width: 100%; margin: 20px auto; border: none;`)
            this.#container_el.setAttribute('data-id', this.#carousel_id)
            location_el[seat](this.#container_el)
            this.#container_window = this.#container_el.contentWindow
            this.#container_doc = this.#container_el.contentDocument
            this.#container_doc.open()
            this.#container_doc.write(`
            <html>
                <head>
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css">
                </head>
                <body>
                    <div class="swiper" style="--swiper-navigation-color: ${this.next_and_prev.color}; --swiper-pagination-color: ${this.pagination.color};">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" style="object-fit: cover; display: flex; justify-content: center; align-items: center; background: ${this.default_item_style.background}"></div>
                            <div class="swiper-slide" style="object-fit: cover; display: flex; justify-content: center; align-items: center; background: ${this.default_item_style.background}"></div>
                        </div>
                        <div class="swiper-button-next"></div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-pagination"></div>
                    </div>
                </body>
            </html>
        `)
            this.#container_doc.close()
            this.#container_el.onload = () => {
                const script_el = document.createElement('script')
                script_el.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js'
                script_el.onload = () => {
                    resolve()
                }
                this.#container_doc.head.appendChild(script_el)
            }
        })
    }

    _createModel() {
        return new this.#container_window.Swiper(this.#container_doc.querySelector('.swiper'), {
            slidesPerView: 1, // 視窗分格
            spaceBetween: 30, // 每項的間距
            loop: true,
            centeredSlides: false,
            autoplay: {
                delay: this.autoplay.delay,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: this.slides_per_view,
                }
            },
        })
    }

    _rgbaFormat(rgba) {
        const [r, g, b, a] = rgba.match(/\d+/g).map(Number)
        const alpha = a ? a : '1'
        return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }

    _percentToNumber(percent) {
        if (!percent) {
            return
        }
        const [res] = percent.match(/\d+/g).map(Number)
        return res
    }

    createModel(element, seat, next_or_previous, create_selector) {
        return new Promise(async (resolve) => {
            if (next_or_previous === 'previous') {
                this.#carousel.destroy()
                this.#carousel = null
                this.#container_el.remove()
                resolve()
            } else if (next_or_previous === 'next') {
                if (!this.#carousel) {
                    this.create_selector = create_selector
                    this.location_el = element
                    this.#regain_model_data.seat = seat
                }
                await this._createModelElement(this.location_el, this.#regain_model_data.seat)
                this.#carousel = this._createModel()
                this.#model_el = this.#container_doc.querySelector('.swiper')
                this.autoplay.status ? this.#carousel.autoplay.start() : this.#carousel.autoplay.stop()
                resolve()
            }
        })
    }

    addItem(next_or_previous) {
        if (next_or_previous === 'previous') {
            const slide_list = []
            this.#container_doc.querySelectorAll(`.swiper-wrapper [data-swiper-slide-index]`).forEach((item) => {
                slide_list.push(Number(item.getAttribute('data-swiper-slide-index')))
            })
            const last_slide_index = Math.max(...slide_list)
            this.#container_doc.querySelector(`.swiper-wrapper [data-swiper-slide-index="${last_slide_index}"]`).remove()
        } else if (next_or_previous === 'next') {
            this.#carousel.appendSlide(`<div class="swiper-slide" style="object-fit: cover; display: flex; justify-content: center; align-items: center; background: ${this.default_item_style.background}"></div>`)
        }

        this.#carousel.update()
        // 因調整後套件會自動關閉播放
        if (this.autoplay.status) {
            this.#carousel.autoplay.start()
        }
    }

    // id 為要刪除的 index
    removeItem(id, next_or_previous) {
        if (next_or_previous === 'previous') {
            this.#container_doc.querySelectorAll(`.swiper-wrapper [data-swiper-slide-index]`).forEach((item, index) => {
                if (index === id) {
                    item.before(this.#remove_slide_history.pop())
                    item.setAttribute('data-swiper-slide-index', String(index + 1))
                } else if (index > id) {
                    item.setAttribute('data-swiper-slide-index', String(index + 1))
                } else {
                    item.after(this.#remove_slide_history.pop())
                }
            })
        } else if (next_or_previous === 'next') {
            // delete slide
            const item_el = this.#container_doc.querySelector(`.swiper-wrapper [data-swiper-slide-index="${id}"]`)
            this.#remove_slide_history.push(item_el)
            item_el.remove()

            // reset slide index
            this.#container_doc.querySelectorAll(`.swiper-wrapper [data-swiper-slide-index]`).forEach((item, index) => {
                item.setAttribute('data-swiper-slide-index', String(index))
            })
        }

        this.#carousel.update()
        // 因調整後套件會自動關閉播放
        if (this.autoplay.status) {
            this.#carousel.autoplay.start()
        }
    }

    editItem(data, next_or_previous) {
        return new Promise((resolve) => {
            const item_block_el = this.#container_doc.querySelector(`.swiper-wrapper [data-swiper-slide-index="${data.item_id}"]`)

            const item_data = next_or_previous === 'previous' ? data.previous_data.items[data.item_id] : data
            // 沒網址直接結束
            if (!item_data.item_url) {
                item_block_el.replaceChildren()
                return resolve()
            }

            let is_iframe = false
            const accept_domains = ['www.instagram.com', 'www.facebook.com', 'www.threads.net']
            accept_domains.forEach((domain) => {
                const embed_domain_regex = new RegExp(domain, 'i')
                if (embed_domain_regex.test(item_data.item_url)) {
                    item_block_el.replaceChildren()
                    is_iframe = true

                    // 特別處理 Facebook iframe
                    if (domain === 'www.facebook.com') {
                        item_block_el.innerHTML = item_data.item_url
                        item_block_el.children[0].removeAttribute('style')
                        item_block_el.children[0].setAttribute('style', `width: ${this.default_item_style.width}%; height: ${this.default_item_style.height}%`)
                        resolve()
                    } else {
                        const iframe_el = document.createElement('iframe')
                        const instagram_style = '<style> body { margin: 0; border: 0; } .instagram-media, .text-post-media { min-width: 0 !important; max-width: 100% !important; width: 100% !important; box-sizing: border-box; border: 0 !important; margin: 0 !important } </style>'
                        iframe_el.setAttribute('style', `border: none; width: ${this.default_item_style.width}%; height: ${this.default_item_style.height}%;`)
                        iframe_el.setAttribute('scrolling', 'no')
                        iframe_el.setAttribute('srcdoc', `${item_data.item_url} ${instagram_style}`)
                        item_block_el.appendChild(iframe_el)
                        resolve()
                    }
                }
            })

            if (!is_iframe) {
                // 沒換格式就直接改 src or href 路徑
                if (item_block_el.children[0]?.nodeName === 'A') {
                    // 在這換掉 src or href 過了就可以了
                    const a_el = item_block_el.querySelector('a')
                    if (item_data.link_url) {
                        a_el.href = item_data.link_url
                        a_el.style.pointerEvents = 'auto'
                    } else {
                        a_el.href = ''
                        a_el.style.pointerEvents = 'none'
                    }
                    const img_el = item_block_el.querySelector('img')
                    if (img_el.src !== item_data.item_url) {
                        img_el.src = item_data.item_url
                    }
                    resolve()
                } else {
                    // 換格式重產 a and img
                    item_block_el.replaceChildren()
                    const a_el = document.createElement('a')
                    a_el.style.display = 'contents'
                    a_el.target = '_blank'
                    if (item_data.link_url) {
                        a_el.href = item_data.link_url
                        a_el.style.pointerEvents = 'auto'
                    } else {
                        a_el.href = ''
                        a_el.style.pointerEvents = 'none'
                    }
                    const img_el = document.createElement('img')
                    img_el.setAttribute('style', `width: ${this.default_item_style.width}%; height: ${this.default_item_style.height}%;`)
                    img_el.src = item_data.item_url
                    img_el.onload = (e) => {
                        resolve()
                    }

                    a_el.appendChild(img_el)
                    item_block_el.appendChild(a_el)
                }
            }

            this.#carousel.update()
            if (this.autoplay.status) {
                this.#carousel.autoplay.start()
            }
        })
    }

    setAutoplay(data, next_or_previous) {
        this.autoplay.status = next_or_previous === 'previous' ? data.previous_data.autoplay.status : data.status
        this.autoplay.delay = next_or_previous === 'previous' ? Number(data.previous_data.autoplay.delay) : Number(data.delay)
        this.#carousel.params.autoplay.delay = this.autoplay.delay
        this.autoplay.status ? this.#carousel.autoplay.start() : this.#carousel.autoplay.stop()
    }

    paginationSwitch(data, next_or_previous) {
        this.pagination.status = next_or_previous === 'previous' ? data.previous_data.pagination.status : data.status
        const pagination_el = this.#container_doc.querySelector(`.swiper-pagination`)
        this.pagination.status ? pagination_el.classList.remove('swiper-pagination-hidden') : pagination_el.classList.add('swiper-pagination-hidden')
    }

    nextAndPrevSwitch(data, next_or_previous) {
        this.next_and_prev.status = next_or_previous === 'previous' ? data.previous_data.next_and_prev.status : data.status
        const next_el = this.#container_doc.querySelector(`.swiper-button-next`)
        const prev_el = this.#container_doc.querySelector(`.swiper-button-prev`)
        this.next_and_prev.status ? next_el.classList.remove('swiper-button-hidden') : next_el.classList.add('swiper-button-hidden')
        this.next_and_prev.status ? prev_el.classList.remove('swiper-button-hidden') : prev_el.classList.add('swiper-button-hidden')
    }

    setPaginationColor(data, next_or_previous) {
        this.pagination.color = next_or_previous === 'previous' ? data.previous_data.pagination.color : data.color
        this.#model_el.style.setProperty('--swiper-pagination-color', this.pagination.color)
        this.#model_el.style.setProperty('--swiper-pagination-bullet-inactive-color', this.pagination.color)
    }

    setNextAndPrevColor(data, next_or_previous) {
        this.next_and_prev.color = next_or_previous === 'previous' ? data.previous_data.next_and_prev.color : data.color
        this.#model_el.style.setProperty('--swiper-navigation-color', this.next_and_prev.color)
    }

    setModelSize(data, next_or_previous) {
        this.model_size = {
            width: next_or_previous === 'previous' ? data.previous_data.model_size.width : data.width,
            height: next_or_previous === 'previous' ? data.previous_data.model_size.height : data.height,
        }
        this.#container_el.style.width = `${this.model_size.width}px`
        this.#container_el.style.height = `${this.model_size.height}px`
        this.#carousel.update()
        // 因調整後套件會自動關閉播放
        if (this.autoplay.status) {
            this.#carousel.autoplay.start()
        }
    }

    setSlidesPerView(data, next_or_previous) {
        this.slides_per_view = next_or_previous === 'previous' ? data.previous_data.slides.per_view : data.amount
        this.#carousel.params.slidesPerView = this.slides_per_view
        this.#carousel.update()
        // 因調整後套件會自動關閉播放
        if (this.autoplay.status) {
            this.#carousel.autoplay.start()
        }
    }

    setItemBackground(data, next_or_previous) {
        const item_el = this.#container_doc.querySelector(`.swiper-wrapper [data-swiper-slide-index="${data.item_id}"]`)
        item_el.style.background = next_or_previous === 'previous' ? data.previous_data.items[data.item_id].background : data.color
    }

    setItemSize(data, next_or_previous) {
        const item_el = this.#container_doc.querySelector(`.swiper-wrapper [data-swiper-slide-index="${data.item_id}"]`)
        if (item_el.children[0].nodeName === 'IFRAME') {
            item_el.children[0].style.setProperty('width', `${next_or_previous === 'previous' ? data.previous_data.items[data.item_id].width : data.width}%`)
            item_el.children[0].style.setProperty('height', `${next_or_previous === 'previous' ? data.previous_data.items[data.item_id].height : data.height}%`)
        } else if (item_el.children[0].nodeName === 'A') {
            item_el.children[0].children[0].style.setProperty('width', `${next_or_previous === 'previous' ? data.previous_data.items[data.item_id].width : data.width}%`)
            item_el.children[0].children[0].style.setProperty('height', `${next_or_previous === 'previous' ? data.previous_data.items[data.item_id].height : data.height}%`)
        }
    }

    getCarouselData() {
        // 重新取得所有項目資料
        this.items = []
        this.#container_doc.querySelectorAll(`.swiper-wrapper [data-swiper-slide-index]`).forEach((item) => {
            const item_index = item.getAttribute('data-swiper-slide-index'),
                item_background = this._rgbaFormat(item.style.background)

            if (!item.children[0]) {
                this.items[item_index] = {
                    height: 100,
                    width: 100,
                    background: item_background,
                }
            } else if (item.children[0].nodeName === 'IFRAME') {
                this.items[item_index] = {
                    node_name: 'IFRAME',
                    item_url: item.children[0].srcdoc || item.children[0].src,
                    height: this._percentToNumber(item.children[0].style.height) || 100,
                    width: this._percentToNumber(item.children[0].style.width) || 100,
                    background: item_background,
                }
            } else if (item.children[0].nodeName === 'A') {
                this.items[item_index] = {
                    node_name: 'IMG',
                    item_url: item.children[0].children[0].currentSrc,
                    link_url: item.children[0].getAttribute('href') || '',
                    height: this._percentToNumber(item.children[0].children[0].style.height) || 100,
                    width: this._percentToNumber(item.children[0].children[0].style.width) || 100,
                    background: item_background,
                }
            }
        })

        return {
            carousel_id: this.#carousel_id,
            items: this.items,
            slides: {
                per_view: this.slides_per_view
            },
            autoplay: {
                status: this.autoplay.status,
                delay: this.autoplay.delay
            },
            pagination: {
                color: this._rgbaFormat(this.pagination.color),
                status: this.pagination.status
            },
            next_and_prev: {
                color: this._rgbaFormat(this.next_and_prev.color),
                status: this.next_and_prev.status
            },
            model_size: {
                height: this.model_size.height,
                width: this.model_size.width
            },
        }
    }

    deleteModel(next_or_previous) {
        return new Promise(async (resolve) => {
            if (next_or_previous === 'previous') {
                // init
                await this._createModelElement(this.location_el, this.#regain_model_data.seat)
                this.#carousel = this._createModel()
                this.#model_el = this.#container_doc.querySelector('.swiper')
                this.setAutoplay(this.#regain_model_data.autoplay, 'next')
                this.setModelSize(this.#regain_model_data.model_size, 'next')
                this.setPaginationColor(this.#regain_model_data.pagination, 'next')
                this.setNextAndPrevColor(this.#regain_model_data.next_and_prev, 'next')
                this.setSlidesPerView({amount: this.#regain_model_data.slides.per_view}, 'next')
                this.paginationSwitch(this.#regain_model_data.pagination, 'next')
                this.nextAndPrevSwitch(this.#regain_model_data.next_and_prev, 'next')

                for (const [index, item] of this.#regain_model_data.items.entries()) {
                    if (item.item_url) {
                        if (index < 2) {
                            await this.editItem({item_id: index, ...item}, 'next')
                            this.setItemSize({item_id: index, ...item}, 'next')
                            this.setItemBackground({item_id: index, color: item.background}, 'next')
                        } else {
                            this.addItem('next')
                            await this.editItem({item_id: index, ...item}, 'next')
                            this.setItemSize({item_id: index, ...item}, 'next')
                            this.setItemBackground({item_id: index, color: item.background}, 'next')
                        }
                    }
                }

                resolve()
            } else if (next_or_previous === 'next') {
                Object.assign(this.#regain_model_data, {...this.getCarouselData()})
                this.#carousel.destroy()
                this.#carousel = null
                this.#container_el.remove()
                resolve()
            }
        })
    }
}